angular.module('zc.zenclerkS')
  .controller('ZcsSetupConversionTagController', ZcsSetupConversionTagController);

ZcsSetupConversionTagController.$inject = ['Project', 'project'];
function ZcsSetupConversionTagController(Project, project) {
  const vm = this;
  let isCompleting = false;

  // variables
  vm.project = project;

  // actions
  vm.save = save;
  vm.onComplete = onComplete;

  activate();

  function activate() {
  }

  function onComplete() {
    if(!vm.project.conversion_tag_confirmed_at && !isCompleting) {
      isCompleting = true;
      vm.project.conversion_tag_confirmed = true;
      Project.update({ projectId: `apikey:${vm.project.apikey}` }, { project: vm.project })
        .then(result => {
          isCompleting = false;
          vm.project = _.merge(vm.project, result);
        });
    }
  }

  function save() {
  }
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/sites/setup/setup_conversion_tag.controller.js